/** @format */

import { head } from './head'
import { interleave } from './interleave'
import { isEmpty } from './isEmpty'
import { tail } from './tail'

export {
  head,
  interleave,
  isEmpty,
  tail,
}
